import { Flex } from "antd";
import TPremiaCard from "../t-premia-card/t-premia-card";
import { TextDescription, TextTitle } from "./style.component";
import Hero from "../hero/hero";
import brandData from "@/assets/brand.json"
import { SizeOfMenu } from "@/pages/logged-page/style-component";
import CustomButton from "../custom-button/custom-button";
import { useUserContext } from "@/contexts/user/useUserContext";
import DOMPurify from 'dompurify';

const CardNextEvent = () => {

  const { logout } = useUserContext();
  return (
    <>
      <SizeOfMenu />
      <TPremiaCard variant='dark' style={{ width: 'fit-content' }}>
        <Hero
          webpSrc={brandData.pages.home.hero.image}
          fallbackSrc={brandData.pages.home.hero.fallback}
          alt="Hero illustration"
          title={<TextTitle dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(`
              ¡Cupos llenos!
            `)
          }} />}
          description={
            <Flex vertical gap={16}>
              <TextDescription
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(`
                Hemos alcanzado el límite de participantes. Pero no te preocupes, podríamos abrir nuevas oportunidades en el futuro. ¡Sigue pendiente!
              `)
                }}
              />
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <CustomButton
                type='primary'
                onClick={logout}
              >
                Finalizar sesión
              </CustomButton>
              </div>
            </Flex>
          }
        />
      </TPremiaCard>
    </>
  );
};

export default CardNextEvent;
